"use strict";
exports.__esModule = true;
exports.errorMessages = void 0;
exports.errorMessages = {
    TITLE_REQUIRED: 'Please select your title',
    FISRT_NAME_REQUIRED: 'Please enter your first name',
    FIRST_NAME_INVALID: 'You can only use letters & dashes here',
    FIRST_NAME_TOO_LONG: 'Please use no more than 20 characters',
    LAST_NAME_REQUIRED: 'Please enter your last name',
    LAST_NAME_INVALID: 'Please only use letters, dashes and apostrophes',
    LAST_NAME_TOO_LONG: 'Please use no more than 40 characters',
    LAST_NAME_TOO_SHORT: 'Your last name must be longer than 1 character',
    ADDRESS1_REQUIRED: 'Please enter the first line of your address e.g. house name or number',
    ADDRESS1_INVALID: "Please only use letters, numbers and characters: & , ' . -",
    ADDRESS1_TOO_LONG: 'You can only use 29 characters here',
    ADDRESS2_REQUIRED: 'Please enter the second line of your address e.g. street or road',
    ADDRESS2_INVALID: "Please only use letters, numbers and characters: & , ' . -",
    ADDRESS2_TOO_LONG: 'You can only use 34 characters here',
    ADDRESS3_INVALID: "Please only use letters, numbers and characters: , ' . -",
    ADDRESS3_TOO_LONG: 'You can only use 50 characters here',
    POSTCODE_REQUIRED: 'Please enter your postcode',
    POSTCODE_UK_INVALID: 'Is this definitely the right postcode?',
    POSTCODE_UK_TOO_SHORT: 'Sorry, your postcode must have 5–8 characters',
    POSTCODE_INVALID: 'You can only use letters & numbers here',
    COUNTY_INVALID: 'Please only use letters, apostrophes and dots',
    COUNTY_TOO_LONG: 'You can only use 20 characters here',
    CITY_REQUIRED: 'Please enter your city or town',
    CITY_INVALID: 'Please only use letters, dashes, apostrophes and dots',
    CITY_TOO_LONG: 'You can only use 50 characters here',
    CITY_TOO_SHORT: 'Please enter at least 3 characters',
    HOME_PHONE_REQUIRED: 'Please enter your phone number',
    HOME_PHONE_INVALID: 'Please only use numbers',
    HOME_PHONE_TOO_LONG: 'Please use no more than 20 digits',
    HOME_PHONE_TOO_SHORT: 'Sorry, your phone number must have at least 10 digits',
    MOBILE_PHONE_REQUIRED: 'Please enter your phone number',
    MOBILE_PHONE_TOO_LONG: 'Please use no more than 20 digits',
    MOBILE_PHONE_TOO_SHORT: 'Your phone number must have at least 11 digits',
    MOBILE_PHONE_INVALID: 'Please enter a valid mobile phone number that contains only numbers, or starts with a +',
    MOBILE_PHONE_UK_INVALID: 'Please enter a valid uk phone number',
    EMAIL_REQUIRED: 'Please enter your email address',
    EMAIL_INVALID: 'Please enter a valid email address',
    EMAIL_INVALID_ARGOS_TOP_LEVEL_DOMAIN: "We can't accept addresses with more than 4 characters after the 'dot'. Please try a different email address.",
    EMAIL_INVALID_MX_DOMAIN: "Sorry, this email address isn't set up to send/receive messages",
    PURCHASE_ORDER_NUMBER_REQUIRED: 'Please enter your purchase order number',
    PURCHASE_ORDER_NUMBER_LENGTH: 'Your purchase order should contain a maximum of 25 characters and no spaces',
    NECTAR_CARD_NUMBER_INVALID: 'Sorry, that Nectar card number is invalid. Please check and try again.',
    ORDER_NUMBER_REQUIRED: 'Please enter your order number',
    GIFTCARD_NUMBER_REQUIRED: 'Please enter a card number starting with either 10000 or 633827',
    GIFTCARD_BIN_RANGE_INVALID: 'Your card number should start with either 10000 or 633827',
    GIFTCARD_LENGTH: 'Your card number should contain 20 numbers',
    GIFTCARD_PIN_REQUIRED: 'Please enter your card PIN number',
    GIFTCARD_PIN_LENGTH: 'Your PIN number should contain 4 numbers',
    FLEXECASH_LENGTH: 'Your card number should contain 19 numbers',
    FLEXECASH_PIN_REQUIRED: 'Please enter your card security number.',
    FLEXECASH_PIN_LENGTH: 'Your card security number should contain 3 numbers',
    FLEXECASH_EXPIRY_REQUIRED: 'Please enter the expiry date',
    FLEXECASH_EXPIRY_INVALID: 'Your expiry date should contain month and year as MM YY',
    FLEXECASH_EXPIRY_EXPIRED: 'Your expiry date must be in the future'
};
//# sourceMappingURL=errorMessages.js.map